import { useQuery } from '@apollo/client';
import { ADMIN_JOB_DETAIL_QUERY } from '@/graphql/queries/jobs.graphql';
import { Job } from './useAdminJobsGraphQL';

/**
 * Admin Job Detail Query Response
 */
export interface AdminJobDetailResponse {
  adminJobDetail: Job | null;
}

/**
 * Admin Job Detail Query Variables
 */
export interface AdminJobDetailVariables {
  id: string;
}

/**
 * Apollo Client hook for fetching individual job details
 * Feature: 073-job-queue-inspector
 *
 * @param id - Job UUID
 * @param options - Apollo Client query options
 * @returns Query result with job detail data, loading state, and error
 *
 * @example
 * ```tsx
 * const { data, loading, error } = useAdminJobDetailGraphQL('550e8400-e29b-41d4-a716-446655440000');
 * ```
 */
export function useAdminJobDetailGraphQL(
  id: string,
  options: {
    skip?: boolean;
  } = {}
) {
  return useQuery<AdminJobDetailResponse, AdminJobDetailVariables>(
    ADMIN_JOB_DETAIL_QUERY,
    {
      variables: { id },
      fetchPolicy: 'network-only', // Always fetch fresh data for detail view
      skip: options.skip || !id, // Skip if no ID provided
    }
  );
}
